export default __webpack_public_path__ + "6ba624e29a66650aae71edd777981b05.svg";